import {
  CHECK_USER_LOCATION,
  CHECK_DARWIN_ATTENDANCE,
  SUBMIT_DARWIN_ATTENDANCE,
} from './type';

const initialState = {
  userLocation: null,
  checkDarwinAttendance: null,
  submitDarwinAttendance: null,
};

export default function darwinReducer(state = initialState, action) {
  switch (action.type) {
    case CHECK_USER_LOCATION:
      return { ...state, userLocation: action.payload };
    case CHECK_DARWIN_ATTENDANCE:
      return { ...state, checkDarwinAttendance: action.payload };
    case SUBMIT_DARWIN_ATTENDANCE:
      return { ...state, submitDarwinAttendance: action.payload };
    default:
      return state;
  }
}
